import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.less'],
  host: {
    '[style.font-size.px]': 'size',
  },
  standalone: true,
})
export class EmojiComponent {
  @Input() public emoji: string;
  @Input() public size: 14 | 20 | 24;
}
